// extracted by mini-css-extract-plugin
module.exports =  {"root":"ixX_szuDNkf6hlTfTI6v","content":"XaeOzITQXZhfnwGExzra","stats":"EnmWC2fxWJS1JaP_suw6"};